import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!key.trim()) {
      setError("API key is required");
      return;
    }
    sessionStorage.setItem('bah_cms_key', key.trim());
    navigate('/admin/dashboard');
  };

  return (
    <div className="flex items-center justify-center min-h-screen -m-8 bg-gray-100">
      <div className="bg-white rounded-lg shadow p-8 w-full max-w-sm">
        <h1 className="text-2xl font-bold mb-1">BAH Admin</h1>
        <p className="text-sm text-gray-500 mb-6">Enter your API key to continue</p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="password"
            placeholder="API key"
            value={key}
            onChange={(e) => setKey(e.target.value)}
            className="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-bahyellow"
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <button
            type="submit"
            className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90"
          >
            Log in
          </button>
        </form>
      </div>
    </div>
  );
}
